import { useEffect } from 'react'
import { AlertCircle, CheckCircle, X } from 'lucide-react'

export default function Notification({ message, type = 'success', onClose, children }) {
  useEffect(() => {
    // Se tiver children (conteúdo complexo), não fecha sozinho tão rápido ou depende do usuário
    const delay = children ? 10000 : 3000
    const timer = setTimeout(onClose, delay)
    return () => clearTimeout(timer)
  }, [onClose, children])

  return (
    <div className={`fixed top-32 left-1/2 -translate-x-1/2 z-[9999] w-[96%] max-w-xl px-4 md:px-6 py-5 rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.6)] flex items-start gap-3 md:gap-4 animate-fade-in border-2 backdrop-blur-xl ${
      type === 'success' ? 'bg-teal-500/20 border-teal-500/50 text-teal-400' : 
      'bg-rose-500/20 border-rose-500/50 text-rose-400'
    }`}>
      <div className={`shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-2xl flex items-center justify-center shadow-inner mt-0.5 ${
        type === 'success' ? 'bg-teal-500/20' : 'bg-rose-500/20'
      }`}>
        {type === 'success' ? <CheckCircle size={28} /> : <AlertCircle size={28} />}
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="font-black text-[10px] uppercase tracking-[0.3em] mb-1 opacity-80">
          {type === 'success' ? 'Sucesso' : 'Atenção'}
        </h4>
        <p className="text-sm md:text-base text-white font-bold leading-snug drop-shadow-sm">
          {message}
        </p>
        {children && (
          <div className="mt-3 pt-3 border-t border-white/10 flex flex-col gap-2">
            {children}
          </div>
        )}
      </div>
      <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full transition-colors self-start -mt-1 -mr-2">
        <X size={20} />
      </button>
    </div>
  )
}
